import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Slider,
  Chip,
  Paper,
  Stack,
  Container,
  IconButton,
  Tooltip,
  Backdrop,
  CircularProgress,
  Alert,
  Snackbar,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Badge,
  Avatar
} from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import {
  AutoFixHigh as MagicIcon,
  Article as DocumentIcon,
  FormatListBulleted as BulletIcon,
  Tune as CustomIcon,
  Mic,
  Upload,
  Delete,
  ContentCopy,
  Download,
  Stop,
  TrendingDown,
  TrendingUp,
  Transform,
  Psychology,
  Create,
  CloudUpload,
  Analytics,
  Speed,
  AutoFixHigh
} from "@mui/icons-material";

import {
  Editor,
  EditorState,
  KeyBindingUtil,
  ContentState,
  convertFromHTML,
  Modifier,
  SelectionState,
  RichUtils,
  CompositeDecorator,
  convertToRaw,
  convertFromRaw,
} from "draft-js";
import "draft-js/dist/Draft.css";
import {
  getCheckSummariser,
  summarizerKeywords,
} from "../../../services/summariserService";
import { checkPhrasing } from "../../../services/englishCheckers";
import { toast, ToastContainer } from "react-toastify";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import mammoth from "mammoth";
import Swal from "sweetalert2";
import { convertToHTML } from "draft-convert";
import { stateFromHTML } from "draft-js-import-html";
import { useSelector } from "react-redux";
import { addUserLogs } from "../../../services/userLogServices";
import { useCheckFeatureAccess } from "../../CheckFeature";
import { useCheckSubscriptionPlanAccess } from "../../SubscriptionAccess";
import SubscriptionRequired from "../../SubscriptionRequired";
import { checkAIRequestLimit } from "../../aiRequestLimit";
import styled from "styled-components";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

// Styled components for better layout control
const StyledCard = styled(Card)`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const CardContentScrollable = styled(CardContent)`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0 !important;
  overflow: hidden;
`;

const EditorContainer = styled(Box)`
  flex: 1;
  overflow: auto;
  min-height: 200px;
`;

const ModeButton = styled(Button)(({ active, disabled }) => ({
  borderRadius: "12px",
  padding: "12px 20px",
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.95rem",
  transition: "all 0.3s ease",
  border: "2px solid #e2e8f0",
  minWidth: "160px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "8px",
  height: "100%",
  
  // Active state
  ...(active && {
    backgroundColor: "#6366f1",
    color: "white",
    borderColor: "#6366f1",
    boxShadow: "0 4px 12px rgba(99, 102, 241, 0.3)",
    transform: "translateY(-2px)",
    "&:hover": {
      backgroundColor: "#4f46e5",
      boxShadow: "0 6px 16px rgba(99, 102, 241, 0.4)",
    },
    "& .MuiSvgIcon-root": {
      color: "white",
    },
    "& .mode-description": {
      color: "rgba(255, 255, 255, 0.9)",
    }
  }),
  
  // Inactive state
  ...(!active && {
    backgroundColor: "transparent",
    color: "#1f2937",
    borderColor: "#e2e8f0",
    "&:hover": {
      backgroundColor: "#f3f4f6",
      borderColor: "#6366f1",
      transform: "translateY(-1px)",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    },
    "& .MuiSvgIcon-root": {
      color: "#6b7280",
    },
    "& .mode-description": {
      color: "#6b7280",
    }
  }),
  
  // Disabled state
  ...(disabled && {
    opacity: 0.5,
    cursor: "not-allowed",
    pointerEvents: "none",
    "&:hover": {
      transform: "none",
      boxShadow: "none",
      borderColor: "#e2e8f0",
    }
  })
}));

const ModernSummarizer = () => {
  const userDetails = useSelector((user) => user);
  const userID = userDetails.user.currentUser._id;
  const [loading, setLoading] = useState(false);
  const [editorState1, setEditorState1] = useState(() =>
    EditorState.createEmpty()
  );
  const [textLength1, setTextLength1] = useState();

  const [editorStatePara, setEditorStatePara] = useState("");
  const [paragraphState, setParagraphState] = useState();
  const [selectedButtons, setSelectedButtons] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const [totalWords, setTotalWords] = useState(0);
  const [totalWords2, setTotalWords2] = useState(0);
  const [activeLink, setActiveLink] = useState(null);
  const [APIData, setAPIData] = useState(false);
  const [sliderValue, setSliderValue] = useState(0);
  const [sliderText, setSliderText] = useState("Shorten");
  const [keywords, setKeywords] = useState([]);
  const [selectedKeywords, setSelectedKeywords] = useState();
  const [isBulletPoints, setIsBulletPoints] = useState(false);
  const [noOfBullets, setNoOfBullets] = useState(0);
  const [isParagraph, setIsParagraph] = useState(false);
  const [isCustom, setIsCustom] = useState(false);
  const [customPrompt, setCustomPrompt] = useState("");
  const [isKeyword, setIsKeyword] = useState(false);
  const [maxCountDisplayed, setMaxCountDisplayed] = useState(false);
  const [isSummarize, setIsSummarize] = useState(false);
  const { transcript, resetTranscript } = useSpeechRecognition();
  const [isRecording, setIsRecording] = useState(false);
  const [isContinuousListening, setIsContinuousListening] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [inputKey, setInputKey] = useState();
  const [showSuccess, setShowSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [noOfParagraphs, setNoOfParagraphs] = useState(0);
  const [customModeText, setCustomModeText] = useState("");

  // Access control hooks
  const accessToUpload = useCheckFeatureAccess("summarizer", "upload");
  const accessToSummarise = useCheckFeatureAccess("summarizer", "summarizer");
  const accessToSummarizerScreen = useCheckSubscriptionPlanAccess("Summarizer");
  const [subReqOpen, setSubReqOpen] = useState(false);
  const [isFeatureInside, setIsFeatureInside] = useState(false);

  const accessTocustom = useCheckSubscriptionPlanAccess("custom")
  const accessToMic = useCheckSubscriptionPlanAccess("mic")

  useEffect(() => {
    if (accessToSummarizerScreen == false) {
      setSubReqOpen(true);
    }
  }, [accessToSummarizerScreen]);

  const { hasCommandModifier } = KeyBindingUtil;
  let [keyCode, setKeyCode] = useState(null);
  const sliderMarks = [
    { value: 0, label: "0%" },
    { value: 20, label: "20%" },
    { value: 40, label: "40%" },
    { value: 60, label: "60%" },
    { value: 80, label: "80%" },
    { value: 100, label: "100%" },
  ];

  let maxWords = 1500;
  const [words, setWords] = useState([]);

  // Dark mode state
  const [isDarkMode, setIsDarkMode] = useState(false);
  useEffect(() => {
    const updateTheme = () => {
      const theme = localStorage.getItem("ThemeSwitch");
      setIsDarkMode(theme === "true");
    };
    updateTheme();
    window.addEventListener("storage", updateTheme);
    const originalSetItem = localStorage.setItem;
    localStorage.setItem = function (key, value) {
      originalSetItem.apply(this, arguments);
      if (key === "ThemeSwitch") {
        updateTheme();
      }
    };
    return () => {
      window.removeEventListener("storage", updateTheme);
      localStorage.setItem = originalSetItem;
    };
  }, []);

  // Decorator for highlighting
  const Decorated = ({ children }) => {
    return <span style={{ color: "darkorange" }}>{children}</span>;
  };

  function findWithRegex(words, contentBlock, callback) {
    const text = contentBlock.getText();
    words.forEach((word) => {
      const matches = [...text.matchAll(word)];
      matches.forEach((match) =>
        callback(match.index, match.index + match[0].length)
      );
    });
  }

  function handleStrategy(contentBlock, callback) {
    findWithRegex(words, contentBlock, callback);
  }

  const createDecorator = () => {
    return new CompositeDecorator([
      {
        strategy: handleStrategy,
        component: Decorated,
      },
    ]);
  };

  const [editorState2, setEditorState2] = useState(
    EditorState.createEmpty(new CompositeDecorator([]))
  );
  const [originalText, setOriginalText] = useState("");
  const [paraphrasedText, setParaphrasedText] = useState("");
  const editor = useRef(null);

  function focusEditor() {
    editor.current.focus();
  }

  const highlightDecorator = (newWords) => {
    return new CompositeDecorator([
      {
        strategy: (contentBlock, callback) => {
          const text = contentBlock.getText();
          newWords.forEach((newWord) => {
            const escapedNewWord = newWord.replace(
              /[.*+?^${}()|[\]\\]/g,
              "\\$&"
            );
            const regex = new RegExp(
              `(?:^|\\W)${escapedNewWord}(?:\\W|$)`,
              "gi"
            );
            let match;
            while ((match = regex.exec(text)) !== null) {
              const startIndex = match.index;
              const endIndex = startIndex + match[0].length;
              callback(startIndex, endIndex);
            }
          });
        },
        component: Decorated,
      },
    ]);
  };

  const changeColors = () => {
    const originalTokens = originalText.split(/\s+/);
    const paraphrasedTokens = paraphrasedText.split(/\s+/);
    const newWords = paraphrasedTokens.filter(
      (word) => !originalTokens.includes(word)
    );
    const dec = highlightDecorator(newWords);
    const contentState = ContentState.createFromText(paraphrasedText);
    setEditorState2(EditorState.createWithContent(contentState, dec));
  };

  useEffect(() => {
    if (paraphrasedText !== "") {
      changeColors();
    }
  }, [paraphrasedText]);

  useEffect(() => {
    if (undefined !== selectedKeywords) {
      summarizeByKeyWord();
    }
  }, [selectedKeywords]);

  const handleWordCountExceed = () => {
    if (!maxCountDisplayed) {
      toast.warn("Word count exceeded than 1500");
      setMaxCountDisplayed(true);
    }
  };

  // MIC FUNCTIONALITY
  const handleMicClick = () => {
    if(accessToMic == false){
      setSubReqOpen(true)
      setIsFeatureInside(true)
      return
    }
    if (SpeechRecognition.browserSupportsSpeechRecognition()) {
      if (isRecording) {
        SpeechRecognition.stopListening();
      } else {
        SpeechRecognition.startListening({ continuous: true });
      }
      setIsRecording(!isRecording);
    } else {
      toast.error("Speech recognition is not supported by your browser.");
    }
  };

  const handleTranscriptChange = () => {
    if (transcript) {
      handleSpeechInput(transcript);
    }
  };

  useEffect(() => {
    return () => {
      if (isRecording) {
        SpeechRecognition.stopListening();
        resetTranscript();
      }
    };
  }, [isRecording]);

  const handleSpeechInput = (input) => {
    const currentText = editorState1.getCurrentContent().getPlainText();
    const newText = `${currentText} ${input}`;
    const newContentState = ContentState.createFromText(newText);
    const newEditorState = EditorState.createWithContent(newContentState);
    setEditorState1(newEditorState);
  };

  useEffect(() => {
    handleTranscriptChange();
    if (transcript.length > 2) {
      resetTranscript();
    }
  }, [transcript]);

  useEffect(() => {
    if (isCustom) {
      if (customPrompt == "") {
        setIsSummarize(true);
      } else {
        setIsSummarize(false);
      }
    }
  }, [customPrompt]);

  useEffect(() => {
    if (isCustom == false) {
      setIsSummarize(false);
    }
  }, [isCustom]);

  useEffect(() => {
    updateWordCount();
  }, [editorState1]);

  useEffect(() => {
    updateWordCount2();
  }, [editorState2]);

  const updateWordCount = () => {
    let contentState = editorState1.getCurrentContent();
    let hasText = contentState.hasText();
    if (hasText) {
      let currentText = contentState.getPlainText();
      let wordCount = currentText.trim().split(/\s+/).length;
      setTotalWords(wordCount);
    } else {
      setTotalWords(0);
    }
  };

  const countWords = (editorState) => {
    const contentState = editorState.getCurrentContent();
    const rawText = convertToRaw(contentState)
      .blocks.map((block) => block.text.trim())
      .join(" ")
      .trim();
    return rawText.length > 0 ? rawText.split(/\s+/).length : 0;
  };

  const wordCountEditor1 = countWords(editorState1);

  const updateWordCount2 = () => {
    let contentState = editorState2.getCurrentContent();
    let hasText = contentState.hasText();
    if (hasText) {
      let currentText = contentState.getPlainText();
      let wordCount = currentText.trim().split(/\s+/).length;
      setTotalWords2(wordCount);
    } else {
      setTotalWords2(0);
    }
  };

  // Function to count paragraphs
  const countParagraphs = (text) => {
    if (!text || text.trim() === "") return 0;
    
    const paragraphs = text.split(/\n\s*\n/).filter(para => para.trim() !== '');
    
    if (paragraphs.length === 0) {
      const lines = text.split('\n').filter(line => line.trim() !== '');
      return lines.length > 0 ? 1 : 0;
    }
    
    return paragraphs.length;
  };

  // Check if output has content
  const hasOutputContent = () => {
    return editorState2.getCurrentContent().hasText();
  };

  const handleKeyWords = async (e) => {
    const checkailimit = await checkAIRequestLimit(userID);
    if (checkailimit == false) {
      toast.warn("AI request limit reached.");
      return;
    }
    let value = e.target.value;
    setSelectedKeywords(value);
  };

  const handleDeleteClick = () => {
    setEditorState1(EditorState.createEmpty());
    setEditorState2(EditorState.createEmpty());
    setEditorStatePara("");
    setTotalWords(0);
    setTotalWords2(0);
    setSliderValue(0);
    setSliderText("Shorten");
    setIsCustom(false);
    setIsVisible(false);
    setMaxCountDisplayed(false);
    resetTranscript();
    setNoOfParagraphs(0);
    setActiveLink(null);
    setCustomModeText("");
    setSuccessMessage("Content cleared successfully!");
    setShowSuccess(true);
  };

  const handleDeleteClick2 = () => {
    setEditorState2(EditorState.createEmpty());
    setEditorStatePara("");
    setTotalWords2(0);
    setSliderValue(0);
    setSliderText("Shorten");
    setIsCustom(false);
    setActiveLink(null);
    setCustomPrompt("");
    setCustomModeText("");
    setMaxCountDisplayed(false);
    resetTranscript();
    setIsBulletPoints(false);
    setNoOfParagraphs(0);
    setIsVisible(false);
    setSuccessMessage("Output cleared successfully!");
    setShowSuccess(true);
  };

  const summarizeByKeyWord = async () => {
    setLoading(true);
    let plainText;
    const selection = editorState1.getSelection();
    plainText = editorState1
      .getCurrentContent()
      .getBlockForKey(selection.getAnchorKey())
      .getText()
      .slice(selection.getStartOffset(), selection.getEndOffset());

    if (!plainText) {
      plainText = editorState1.getCurrentContent().getPlainText();
    }

    let sendData = {
      text: selectedKeywords,
      content: plainText,
      prompts: "three",
      userId: userID,
      isCoAuthor: false,
    };

    try {
      let response = await getCheckSummariser(sendData);
      if (response.data.output[0].startsWith("\n")) {
        response.data.output[0] = response.data.output[0].substring(1);
      }
      const summaryText = response.data.output.join("\n");
      const newContentState = ContentState.createFromText(summaryText);
      let newEditorState = EditorState.createWithContent(newContentState);
      setEditorState2(newEditorState);
      setActiveLink("paragraph")
      setEditorStatePara(newEditorState.getCurrentContent().getPlainText());
      
      const paragraphCount = countParagraphs(summaryText);
      setNoOfParagraphs(paragraphCount);
      
      const data = {
        userId: sessionStorage.getItem("userId"),
        organizationId: sessionStorage.getItem("organizationId"),
        actionType: "summariser",
      };
      const addLogs = await addUserLogs(data);
      if (addLogs.status !== 200) {
        setActiveLink(null)
        toast.error(addLogs.message);
      }
    } catch (e) {
      console.log("summarizeByKeyWorderror", e);
      setActiveLink(null);
    }
    setLoading(false);
  };

  const summarizeByPercentage = async (value) => {
    let promptValue = "four";
    let newValue;
    if (value == 0) {
      handleSummeriseClick(false);
      return;
    } else if (value < 60) {
      newValue = 100 - value;
      promptValue = "four";
    } else if (value == 60) {
      newValue = 40;
      promptValue = "five";
    } else if (value > 60) {
      newValue = value;
      promptValue = "five";
    }

    let plainText;
    const selection = editorState1.getSelection();
    plainText = editorState1
      .getCurrentContent()
      .getBlockForKey(selection.getAnchorKey())
      .getText()
      .slice(selection.getStartOffset(), selection.getEndOffset());

    if (!plainText) {
      plainText = editorState1.getCurrentContent().getPlainText();
    }

    let sendData = {
      text: newValue.toString() + "%",
      content: plainText,
      prompts: promptValue,
      userId: userID,
      isCoAuthor: false,
    };

    setLoading(true);
    try {
      let response = await getCheckSummariser(sendData);
      if (response.data.output[0].startsWith("\n")) {
        response.data.output[0] = response.data.output[0].substring(1);
      }
      const summaryText = response.data.output.join("\n");
      const newContentState = ContentState.createFromText(summaryText);
      let newEditorState = EditorState.createWithContent(newContentState);
      setEditorState2(newEditorState);
      setActiveLink("paragraph")
      setEditorStatePara(newEditorState.getCurrentContent().getPlainText());
      
      const paragraphCount = countParagraphs(summaryText);
      setNoOfParagraphs(paragraphCount);
      
      const data = {
        userId: sessionStorage.getItem("userId"),
        organizationId: sessionStorage.getItem("organizationId"),
        actionType: "summariser",
      };
      const addLogs = await addUserLogs(data);
      if (addLogs.status !== 200) {
        toast.error(addLogs.message);
      }
    } catch (e) {
      setActiveLink(null)
      console.log("summarizeByPercentageerror", e);
    }
    setLoading(false);
  };

  const handleCopyEditor1 = () => {
    let sentence = editorState1.getCurrentContent().getPlainText();
    if (sentence == "") {
      toast.warn(`You don't have text, to copy`);
      return;
    }
    navigator.clipboard.writeText(sentence).then(
      function () {
        setSuccessMessage("Text copied successfully!");
        setShowSuccess(true);
      },
      function (err) {
        console.error("Async: Could not copy text: ", err);
      }
    );
  };

  const handleCopyEditor2 = () => {
    let sentence = editorState2.getCurrentContent().getPlainText();
    if (sentence == "") {
      toast.warn(`You don't have text, to copy`);
      return;
    }
    navigator.clipboard.writeText(sentence).then(
      function () {
        setSuccessMessage("Summary copied successfully!");
        setShowSuccess(true);
      },
      function (err) {
        console.error("Async: Could not copy text: ", err);
      }
    );
  };

  const handleDownload = () => {
    if (!editorState2.getCurrentContent().getPlainText()) {
      toast.warn(`You don't have text, to download`);
      return;
    }
    const blob = new Blob([editorState2.getCurrentContent().getPlainText()], {
      type: "text/plain",
    });
    const anchor = document.createElement('a');
    anchor.href = URL.createObjectURL(blob);
    anchor.download = "text_content.doc";
    anchor.click();
    URL.revokeObjectURL(anchor.href);
    setSuccessMessage("File downloaded successfully!");
    setShowSuccess(true);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.type === "application/pdf") {
      toast.warn("PDF format is not supported.");
      return;
    }

    if (file.size > 4194304) {
      Swal.fire({
        title: "Document exceeded the limit of 4 Mb!",
        type: "error",
        confirmButtonText: "ok",
      });
      return;
    }

    if (
      file.type ===
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ) {
      let reader = new FileReader();
      reader.onload = function (event) {
        mammoth
          .convertToHtml({ arrayBuffer: event.target.result })
          .then(function (result) {
            const contentState = stateFromHTML(result.value);
            setEditorState1(EditorState.createWithContent(contentState));
            setSuccessMessage("File uploaded successfully!");
            setShowSuccess(true);
          })
          .done();
      };
      reader.readAsArrayBuffer(file);
    } else if (file.type === "text/plain") {
      let reader = new FileReader();
      reader.onload = function (event) {
        const contentState = ContentState.createFromText(event.target.result);
        setEditorState1(EditorState.createWithContent(contentState));
        setSuccessMessage("File uploaded successfully!");
        setShowSuccess(true);
      };
      reader.readAsText(file);
    } else {
      toast.info(
        "Your file format is not supported, Please upload txt or doc files."
      );
    }
  };

  const handleParaphrase = async () => {
    const checkailimit = await checkAIRequestLimit(userID);
    if (checkailimit == false) {
      toast.warn("AI request limit reached.");
      return;
    }
    setActiveLink("paragraph");
    setAPIData(false);
    setIsBulletPoints(false);
    setIsParagraph(true);
    setIsCustom(false);
    setIsKeyword(true);
    GrammerCheckForParaphrase();
  };

  const handleCustomPrompt = (e) => {
    let value = e.target.value;
    setCustomPrompt(value);
  };

  const GrammerCheckForParaphrase = async (type) => {
    let plainText;
    const selection = editorState2.getSelection();
    plainText = editorState2
      .getCurrentContent()
      .getBlockForKey(selection.getAnchorKey())
      .getText()
      .slice(selection.getStartOffset(), selection.getEndOffset());

    if (!plainText) {
      plainText = editorState2.getCurrentContent().getPlainText();
    }

    let data = {
      text: plainText,
      tone: "defaultPrompt",
      userId: userID,
      isCoAuthor: false,
    };

    setLoading(true);
    try {
      let paraphraseResponse = await checkPhrasing(data);
      if (paraphraseResponse.data !== "") {
        if (paraphraseResponse.data.output[0].startsWith("\n")) {
          paraphraseResponse.data.output[0] =
            paraphraseResponse.data.output[0].substring(1);
        }
        const summaryText = paraphraseResponse.data.output.join("\n");
        let responseOutput = ContentState.createFromText(summaryText);
        let newEditorState = EditorState.createWithContent(responseOutput);
        setEditorState2(newEditorState);
        handleReplaceText(newEditorState);
        setEditorStatePara(newEditorState.getCurrentContent().getPlainText());
        
        const paragraphCount = countParagraphs(summaryText);
        setNoOfParagraphs(paragraphCount);
        
        const data = {
          userId: sessionStorage.getItem("userId"),
          organizationId: sessionStorage.getItem("organizationId"),
          actionType: "paraphrase",
        };
        const addLogs = await addUserLogs(data);
        if (addLogs.status !== 200) {
          toast.error(addLogs.message);
        }
      }
    } catch (e) {
      console.log("error", e);
    }
    setLoading(false);
  };

  const handleReplaceText = (newEditorState) => {
    let newState = newEditorState.getCurrentContent();
    let newText = newState.getPlainText();
    let previousState = editorState2.getCurrentContent();
    let previousText = previousState.getPlainText();
    const replacedContentState = ContentState.createFromText(newText);
    setOriginalText(previousText);
    setParaphrasedText(newText);
  };

  const handleParagraph = () => {
    const contentState = ContentState.createFromText(editorStatePara);
    const editorStateWithText = EditorState.createWithContent(contentState);
    setEditorState2(editorStateWithText);
    
    const paragraphCount = countParagraphs(editorStatePara);
    setNoOfParagraphs(paragraphCount);
    
    return;
  };

  const handleLinkClick = (linkType) => {
    setActiveLink(linkType);
    
    // Reset all states first
    setIsBulletPoints(false);
    setIsParagraph(false);
    setIsCustom(false);
    setCustomPrompt("");
    setIsKeyword(false);
    
    if (linkType === "bullets") {
      setAPIData(true);
      setIsBulletPoints(true);
      handleApplyBullets();
    } else if (linkType === "paragraph") {
      setAPIData(false);
      setIsParagraph(true);
      setIsKeyword(true);
      handleParagraph();
    } else if (linkType === "custom") {
      // if(accessTocustom == false){
      //   setSubReqOpen(true)
      //   setIsFeatureInside(true)
      //   return
        
      // } 
      setIsCustom(true);
      setIsSummarize(true);
      setCustomModeText("Enter custom instructions...");
    }
  };

  const handleCustomModeApply = () => {
     if(accessTocustom == false){
        setSubReqOpen(true)
        setIsFeatureInside(true)
        return
     
      }

    if (customPrompt.trim() !== "") {
      handleSummeriseClick(false);
      setCustomModeText(`Custom: ${customPrompt.substring(0, 30)}${customPrompt.length > 30 ? '...' : ''}`);
    }
  };

  const handleEditorChange = (newEditorState) => {
    const contentState = newEditorState.getCurrentContent();
    const currentText = contentState.getPlainText();
    let hasText = contentState.hasText();
    const wordCount = currentText.split(/\s+/).length;
    setEditorState1(newEditorState);
    setMaxCountDisplayed(false);
    setTotalWords(hasText ? wordCount : 0);
  };

  const handleEditorChange2 = (newEditorState) => {
    const contentState = newEditorState.getCurrentContent();
    const currentText = contentState.getPlainText();
    const wordCount = currentText.split(/\s+/).length;

    let lines = currentText.split("\n").filter((line) => line.trim() !== "");
    let textWithoutEmptyLines = lines.join("\n");
    const sentenceSplitPattern = /(?<!\b(?:[A-Z][a-z]*\.?\s?)+)\.\s+/;
    let sentences = textWithoutEmptyLines
      .split(sentenceSplitPattern)
      .filter((sentence) => sentence.trim() !== "")
      .map((sentence) => sentence.replace(/\n/g, ""));

    let hasText = contentState.hasText();
    if (wordCount > maxWords) {
      handleWordCountExceed();
      return;
    }

    setNoOfBullets(sentences.length);
    setTotalWords2(hasText ? wordCount : 0);
    setEditorState2(newEditorState);
    setMaxCountDisplayed(false);
    
    if (isParagraph) {
      const paragraphCount = countParagraphs(currentText);
      setNoOfParagraphs(paragraphCount);
    }

    if (hasText && !isVisible) {
      setIsVisible(true);
    } else if (!hasText && isVisible) {
      setIsVisible(false);
    }
  };

  const handleSummeriseClick = async (isDefault) => {
    const checkailimit = await checkAIRequestLimit(userID);
    if (checkailimit == false) {
      toast.warn("AI request limit reached.");
      return;
    }

    if (
      editorState1.getCurrentContent().getPlainText().split(/\s+/).length > 1500
    ) {
      toast.warn("Words limit exceeded");
      return;
    }

    // Reset slider value when summarize is clicked
    setSliderValue(0);
    setSliderText("Shorten");

    setLoading(true);
    try {
      if (
        editorState1.getCurrentContent().getPlainText().split(/\s+/).length -
        1 ==
        0
      ) {
        toast.warn("Please enter text");
        return;
      } else {
        const contentState = editorState1.getCurrentContent();
        let plainText;
        const selection = editorState1.getSelection();
        plainText = editorState1
          .getCurrentContent()
          .getBlockForKey(selection.getAnchorKey())
          .getText()
          .slice(selection.getStartOffset(), selection.getEndOffset());

        if (!plainText) {
          plainText = contentState.getPlainText();
        }

        let sendData = {
          text: plainText,
          content: "",
          prompts: isDefault ? "one" : "seven",
          userId: userID,
          isCoAuthor: false,
        };

        if (customPrompt !== "") {
          sendData = {
            text: customPrompt,
            content: plainText,
            prompts: "six",
            userId: userID,
            isCoAuthor: false,
          };
        }

        setLoading(true);
        let generateSummary = await getCheckSummariser(sendData);
        if (generateSummary.data.output[0].startsWith("\n")) {
          generateSummary.data.output[0] =
            generateSummary.data.output[0].substring(1);
        }
        const summaryText = generateSummary.data.output.join("\n");
        const newContentState = ContentState.createFromText(summaryText);
        const newEditorState = EditorState.createWithContent(newContentState);
        setEditorState2(newEditorState);
        setActiveLink("paragraph")
        setEditorStatePara(newEditorState.getCurrentContent().getPlainText());

        // Update paragraph count
        const paragraphCount = countParagraphs(summaryText);
        setNoOfParagraphs(paragraphCount);

        let sendData2 = {
          text: plainText,
          prompts: "two",
          userId: userID,
          isCoAuthor: false,
        };

        let generateKeywords = await getCheckSummariser(sendData2);
        let text = generateKeywords.data.output[0];

        let allkeywords = text
          .split(/\n/)
          .map((line) => line.trim())
          .filter((line) => line.length > 0)
          .map((line) => line.replace(/^[\d.-\s]*/, ""));

        let formattedKeywords = allkeywords.map((keyword) => ({
          name: keyword,
          value: keyword,
        }));

        setKeywords(formattedKeywords);
        setIsVisible(true);
        setIsKeyword(isCustom ? false : true);
        const data = {
          userId: sessionStorage.getItem("userId"),
          organizationId: sessionStorage.getItem("organizationId"),
          actionType: "summariser",
        };
        const addLogs = await addUserLogs(data);
        if (addLogs.status !== 200) {
          toast.error(addLogs.message);
        }
      }
    } catch (error) {
      console.error("summarizeClick", error);
      toast.error("Error Occurred");
    }
    setLoading(false);
  };

  const handleApplyBullets = () => {
    let hasText = editorState2.getCurrentContent().hasText();
    if (!hasText) {
      toast.info("No content to add bullets");
      return;
    }
    setIsBulletPoints(true);
    setIsParagraph(false);
    setIsCustom(false);
    setIsKeyword(true);

    let text = editorState2.getCurrentContent().getPlainText();

    let lines = text.split("\n").filter((line) => line.trim() !== "");
    let textWithoutEmptyLines = lines.join("\n");

    const sentenceSplitPattern = /(?<!\b(?:[A-Z][a-z]*\.?\s?)+)\.\s+/;
    let sentences = textWithoutEmptyLines
      .split(sentenceSplitPattern)
      .filter((sentence) => sentence.trim() !== "")
      .map((sentence) => sentence.replace(/\n/g, ""));
    setNoOfBullets(sentences.length);

    let formattedText = sentences.join(".\n");
    let newContent = ContentState.createFromText(formattedText);
    let newEditorState = EditorState.createWithContent(newContent);
    let newEditorStateExt = newEditorState.getCurrentContent();
    let firstBlock = newEditorStateExt.getFirstBlock();
    let lastBlock = newEditorStateExt.getLastBlock();
    let firstBlockKey = firstBlock.getKey();
    let lastBlockKey = lastBlock.getKey();
    let firstBlockLength = firstBlock.getLength();
    let lastBlockLength = lastBlock.getLength();
    let selection = newEditorState.getSelection().merge({
      anchorKey: firstBlockKey,
      anchorOffset: 0,
      focusKey: lastBlockKey,
      focusOffset: lastBlockLength,
    });
    let selectedState = EditorState.forceSelection(newEditorState, selection);
    setParagraphState(selectedState);

    let newEditorState2 = RichUtils.toggleBlockType(
      selectedState,
      "unordered-list-item"
    );
    setEditorState2(newEditorState2);
  };

  const handleSliderChange = async (event, newValue) => {
    const checkailimit = await checkAIRequestLimit(userID);
    if (checkailimit == false) {
      toast.warn("AI request limit reached.");
      return;
    }
    const percentage = ((newValue - 0) / (100 - 0)) * 100;
    setSliderValue(newValue);
    setSliderText(newValue >= 60 ? "Expand" : "Shorten");
    summarizeByPercentage(newValue);
  };

  // Update windowWidth on resize
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const modes = [
    {
      id: "paragraph",
      label: "Paragraph",
      icon: DocumentIcon,
      description: "Traditional paragraph format",
    },
    {
      id: "bullets",
      label: "Bullet Points",
      icon: BulletIcon,
      description: "Convert to bullet points",
    },
    {
      id: "custom",
      label: "Custom",
      icon: CustomIcon,
      description: "Custom instructions",
    },
  ];

  return (
    <>
      <SubscriptionRequired open={subReqOpen} setOpen={setSubReqOpen} isFeatureInside={isFeatureInside} setIsFeatureInside={setIsFeatureInside} path={"Summarizer"} />
      <Box
        sx={{
          background: isDarkMode
            ? "linear-gradient(135deg, #1e293b 0%, #334155 100%)"
            : "linear-gradient(135deg, #ffffffff 0%, #d3d1d1ff)",
          p: 3,
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Container maxWidth="xl" sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
          <div style={{ display: "flex", justifyContent: 'space-between' }}>
            <div>
              {/* Header */}
              <Box sx={{ mb: 2, position: "relative" }}>
                <Typography
                  variant="h4"
                  sx={{
                    color: "white",
                    fontWeight: 800,
                    color: 'primary.main',
                    mb: 1,
                    textShadow: "0 2px 4px rgba(0,0,0,0.3)",
                  }}
                >
                  AI Summarizer
                </Typography>
                <Typography
                  variant="caption"
                  sx={{ color: 'text.secondary', fontStyle: 'italic' }}
                >
                  Transform your text with intelligent summarization
                </Typography>
              </Box>
            </div>
            <div>
              <Link to="/docTags" t>
                 <Button
                    variant="contained"
                    sx={{
                      background:
                        "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                      color: "#fff",
                      borderRadius: 3,
                      whiteSpace: "nowrap",
                      minWidth: "120px",
                      px: 3,
                      py: 1.2,
                      fontWeight: 600,
                      textTransform: "none",
                      fontSize: "0.95rem",
                      boxShadow: "0 4px 15px rgba(102, 126, 234, 0.3)",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        background:
                          "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
                        transform: "translateY(-2px)",
                        boxShadow: "0 6px 20px rgba(102, 126, 234, 0.4)",
                      },
                    }}
                  >
                    ← Back
                  </Button>

              </Link>
            </div>
          </div>

          {/* Mode Selection - Redesigned */}
          <Card
            sx={{
              mb: 3,
              borderRadius: 4,
              background: isDarkMode
                ? "rgba(30, 41, 59, 0.95)"
                : "rgba(255,255,255,0.95)",
              backdropFilter: "blur(10px)",
              boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
              border: isDarkMode ? "1px solid #475569" : "1px solid #e2e8f0",
            }}
          >
            <CardContent sx={{ p: 3 }}>
              <Grid2 container spacing={3} alignItems="center">
                <Grid2 item xs={12} md={8}>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1, color: isDarkMode ? "white" : "text.primary" }}>
                      Output Format
                    </Typography>
                    <Typography variant="body2" sx={{ color: isDarkMode ? "#94a3b8" : "text.secondary", mb: 2 }}>
                      Select how you want to display the summarized content
                    </Typography>
                  </Box>
                  
                  <Grid2 container spacing={2}>
                    {modes.map((mode) => {
                      const IconComponent = mode.icon;
                      const isActive = activeLink === mode.id;
                      const isDisabled = mode.id === "custom" && !hasOutputContent() ? false : !hasOutputContent();
                      
                      return (
                        <Grid2 item xs={12} sm={4} key={mode.id}>
                          <ModeButton
                            fullWidth
                            active={isActive}
                            disabled={isDisabled}
                            onClick={() => handleLinkClick(mode.id)}
                          >
                            <IconComponent sx={{ fontSize: 28 }} />
                            <Typography variant="subtitle1" fontWeight={600}>
                              {mode.label}
                            </Typography>
                            <Typography variant="caption" className="mode-description" sx={{ textAlign: 'center' }}>
                              {mode.description}
                            </Typography>
                            {isActive && (
                              <Box sx={{ 
                                position: 'absolute', 
                                top: 4, 
                                right: 4,
                                width: 8,
                                height: 8,
                                borderRadius: '50%',
                                bgcolor: 'primary.main'
                              }} />
                            )}
                          </ModeButton>
                        </Grid2>
                      );
                    })}
                  </Grid2>
                  
                  {activeLink === "custom" && (
                    <Box sx={{ mt: 3 }}>
                      <Grid2 container spacing={2} alignItems="center">
                        <Grid2 item xs={12} md={8}>
                          <TextField
                            fullWidth
                            size="small"
                            placeholder="Enter custom instructions (e.g., 'Summarize in 3 sentences', 'Make it more formal')"
                            value={customPrompt}
                            onChange={(e) => setCustomPrompt(e.target.value)}
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                borderRadius: 2,
                              }
                            }}
                          />
                        </Grid2>
                        <Grid2 item xs={12} md={4}>
                          <Button
                            fullWidth
                            variant="contained"
                            onClick={handleCustomModeApply}
                            disabled={!customPrompt.trim()}
                            sx={{
                              borderRadius: 2,
                              py: 1,
                              fontWeight: 600,
                            }}
                          >
                            Apply
                          </Button>
                        </Grid2>
                      </Grid2>
                    </Box>
                  )}
                </Grid2>
                
                <Grid2 item xs={12} md={4}>
                  <Box sx={{ 
                    p: 2, 
                    borderRadius: 3, 
                    bgcolor: isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)',
                    border: `1px solid ${isDarkMode ? '#475569' : '#e2e8f0'}` 
                  }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}>
                      <TrendingDown color={sliderValue >= 60 ? "secondary" : "primary"} />
                      <Box sx={{ flex: 1 }}>
                        <Typography variant="body2" sx={{ color: isDarkMode ? "#94a3b8" : "text.secondary", mb: 0.5 }}>
                          {sliderText} Text
                        </Typography>
                        <Slider
                          value={sliderValue}
                          onChange={handleSliderChange}
                          step={20}
                          marks={sliderMarks}
                          min={0}
                          max={100}
                          disabled={!hasOutputContent()}
                          sx={{
                            "& .MuiSlider-thumb": {
                              background:
                                sliderValue >= 60 
                                  ? "linear-gradient(45deg, #f97316, #ea580c)"
                                  : "linear-gradient(45deg, #667eea, #764ba2)",
                              border: "3px solid white",
                              boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                            },
                            "& .MuiSlider-track": {
                              background:
                                sliderValue >= 60 
                                  ? "linear-gradient(45deg, #f97316, #ea580c)"
                                  : "linear-gradient(45deg, #667eea, #764ba2)",
                            },
                          }}
                        />
                      </Box>
                      <TrendingUp color={sliderValue >= 60 ? "primary" : "secondary"} />
                    </Box>
                    <Typography variant="caption" sx={{ 
                      display: 'block', 
                      textAlign: 'center',
                      color: isDarkMode ? "#94a3b8" : "text.secondary",
                      mt: 1
                    }}>
                      Adjust length: {sliderValue}%
                    </Typography>
                  </Box>
                </Grid2>
              </Grid2>
            </CardContent>
          </Card>

          {/* Main Content - Fixed height and alignment */}
          <Grid2 container spacing={3} sx={{ flex: 1, alignItems: 'stretch' }}>
            {/* Input Panel */}
            <Grid2 item xs={12} lg={6}>
              <StyledCard
                sx={{
                  borderRadius: 4,
                  background: isDarkMode
                    ? "rgba(30, 41, 59, 0.95)"
                    : "rgba(255,255,255,0.95)",
                  backdropFilter: "blur(10px)",
                  boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
                }}
              >
                {/* Input Header */}
                <Box
                  sx={{
                    background: "linear-gradient(45deg, #667eea, #764ba2)",
                    color: "white",
                    p: 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  <Avatar sx={{ bgcolor: "rgba(255,255,255,0.2)" }}>
                    <Create />
                  </Avatar>
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="h6" fontWeight={600}>
                      Input Text
                    </Typography>
                    <Typography variant="body2" sx={{ opacity: 0.9 }}>
                      Enter or upload your content
                    </Typography>
                  </Box>
                  <Badge badgeContent={totalWords} max={1500} color="warning">
                    <Chip
                      label={`${wordCountEditor1}/1500`}
                      size="small"
                      sx={{
                        bgcolor: "rgba(255,255,255,0.2)",
                        color: "white",
                        fontWeight: 600,
                      }}
                    />
                  </Badge>
                </Box>

                {/* Editor */}
                <CardContentScrollable>
                  <EditorContainer
                    sx={{
                      minHeight: 400,
                      maxHeight: 400,
                      p: 2,
                      overflow: "scroll",
                      "& .DraftEditor-root": {
                        color: isDarkMode ? "white" : "inherit",
                      },
                      "& .public-DraftEditorPlaceholder-root": {
                        color: isDarkMode ? "#94a3b8" : "#999",
                      },
                    }}
                  >
                    <Editor
                      editorState={editorState1}
                      onChange={handleEditorChange}
                      placeholder="Start typing your text here, or use the upload button to add a document..."
                    />
                  </EditorContainer>
                </CardContentScrollable>

                {/* Action Bar */}
                <Box
                  sx={{
                    p: 2,
                    background: isDarkMode
                      ? "linear-gradient(45deg, #334155, #475569)"
                      : "linear-gradient(45deg, #f8fafc, #e2e8f0)",
                    borderTop: isDarkMode
                      ? "1px solid #475569"
                      : "1px solid #e2e8f0",
                  }}
                >
                  <Stack
                    direction="row"
                    spacing={1}
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Stack direction="row" spacing={1}>
                      <Tooltip title="Voice Input">
                        <IconButton
                          onClick={handleMicClick}
                          disabled={!accessToSummarise}
                          sx={{
                            color: isRecording
                              ? "#ef4444"
                              : isDarkMode
                                ? "#94a3b8"
                                : "#6b7280",
                            animation: isRecording
                              ? "pulse 1s infinite"
                              : "none",
                          }}
                        >
                          {isRecording ? <Stop /> : <Mic />}
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Upload Document">
                        <IconButton
                          component="label"
                          disabled={!accessToUpload}
                          sx={{ color: isDarkMode ? "#94a3b8" : "#6366f1" }}
                        >
                          <CloudUpload />
                          <VisuallyHiddenInput
                            type="file"
                            key={inputKey}
                            onChange={handleFileChange}
                            accept=".txt,.doc,.docx"
                          />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Clear All">
                        <IconButton
                          onClick={handleDeleteClick}
                          sx={{ color: "#ef4444" }}
                        >
                          <Delete />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Copy Text">
                        <IconButton
                          onClick={handleCopyEditor1}
                          sx={{ color: "#10b981" }}
                        >
                          <ContentCopy />
                        </IconButton>
                      </Tooltip>
                    </Stack>

                    <Button
                      variant="contained"
                      size="large"
                      onClick={() => handleSummeriseClick(true)}
                      startIcon={<MagicIcon />}
                      disabled={
                        loading ||
                        totalWords === 0 ||
                        isSummarize ||
                        !accessToSummarise
                      }
                      sx={{
                        background: "linear-gradient(45deg, #667eea, #764ba2)",
                        borderRadius: 3,
                        px: 3,
                        py: 1.5,
                        fontWeight: 600,
                        fontSize: "1.1rem",
                        boxShadow: "0 4px 16px rgba(102,126,234,0.4)",
                        "&:hover": {
                          transform: "translateY(-2px)",
                          boxShadow: "0 8px 24px rgba(102,126,234,0.6)",
                        },
                        transition: "all 0.3s ease",
                      }}
                    >
                      {loading ? "Processing..." : "Summarize"}
                    </Button>
                  </Stack>
                </Box>
              </StyledCard>
            </Grid2>

            {/* Output Panel */}
            <Grid2 item xs={12} lg={6}>
              <StyledCard
                sx={{
                  borderRadius: 4,
                  background: isDarkMode
                    ? "rgba(30, 41, 59, 0.95)"
                    : "rgba(255,255,255,0.95)",
                  backdropFilter: "blur(10px)",
                  boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
                }}
              >
                {/* Output Header */}
                <Box
                  sx={{
                    background: "linear-gradient(45deg, #10b981, #059669)",
                    color: "white",
                    p: 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  <Avatar sx={{ bgcolor: "rgba(255,255,255,0.2)" }}>
                    <Analytics />
                  </Avatar>
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="h6" fontWeight={600}>
                      Generated Summary
                    </Typography>
                    <Typography variant="body2" sx={{ opacity: 0.9 }}>
                      {hasOutputContent() 
                        ? (isBulletPoints
                            ? `${noOfBullets} bullet points`
                            : `${noOfParagraphs} paragraph${noOfParagraphs !== 1 ? 's' : ''}`)
                        : "Processed content"}
                    </Typography>
                  </Box>
                  {hasOutputContent() && (
                    <Chip
                      label={`${totalWords2} words`}
                      size="small"
                      sx={{
                        bgcolor: "rgba(255,255,255,0.2)",
                        color: "white",
                        fontWeight: 600,
                      }}
                    />
                  )}
                </Box>

                {/* Output Content */}
                <CardContentScrollable>
                  {!hasOutputContent() ? (
                    <Box
                      sx={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        color: isDarkMode ? "#94a3b8" : "#6b7280",
                        p: 3,
                        minHeight: 400,
                        maxHeight: 400,
                        overflow: "scroll"
                      }}
                    >
                      <Psychology sx={{ fontSize: 64, mb: 2, opacity: 0.3 }} />
                      <Typography variant="h6" gutterBottom>
                        Ready to Summarize
                      </Typography>
                      <Typography
                        variant="body2"
                        textAlign="center"
                        sx={{ maxWidth: 300 }}
                      >
                        Enter your text and click summarize to see the magic
                        happen
                      </Typography>
                    </Box>
                  ) : (
                    <EditorContainer
                      sx={{
                        minHeight: 400,
                        maxHeight: 400,
                        overflow: "scroll",
                        p: 2,
                        "& .DraftEditor-root": {
                          color: isDarkMode ? "white" : "inherit",
                        },
                      }}
                    >
                      <Editor
                        ref={editor}
                        editorState={editorState2}
                        onChange={handleEditorChange2}
                      />
                    </EditorContainer>
                  )}
                </CardContentScrollable>

                {/* Output Action Bar */}
                {hasOutputContent() && (
                  <Box
                    sx={{
                      p: 2,
                      background: isDarkMode
                        ? "linear-gradient(45deg, #065f46, #047857)"
                        : "linear-gradient(45deg, #ecfdf5, #d1fae5)",
                      borderTop: isDarkMode
                        ? "1px solid #047857"
                        : "1px solid #d1fae5",
                    }}
                  >
                    <Stack
                      direction="row"
                      spacing={1}
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Stack direction="row" spacing={1}>
                        <Tooltip title="Clear Output">
                          <IconButton
                            onClick={handleDeleteClick2}
                            sx={{ color: "#ef4444" }}
                          >
                            <Delete />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Copy Summary">
                          <IconButton
                            onClick={handleCopyEditor2}
                            sx={{ color: "#10b981" }}
                          >
                            <ContentCopy />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Download">
                          <IconButton
                            onClick={handleDownload}
                            sx={{ color: "#3b82f6" }}
                          >
                            <Download />
                          </IconButton>
                        </Tooltip>
                      </Stack>

                      <Button
                        variant="contained"
                        size="large"
                        onClick={handleParaphrase}
                        startIcon={<Transform />}
                        disabled={loading}
                        sx={{
                          background:
                            "linear-gradient(45deg, #10b981, #059669)",
                          borderRadius: 3,
                          px: 3,
                          py: 1.5,
                          fontWeight: 600,
                          fontSize: "1.1rem",
                          boxShadow: "0 4px 16px rgba(16,185,129,0.4)",
                          "&:hover": {
                            transform: "translateY(-2px)",
                            boxShadow: "0 8px 24px rgba(16,185,129,0.6)",
                          },
                          transition: "all 0.3s ease",
                        }}
                      >
                        Paraphrase
                      </Button>
                    </Stack>
                  </Box>
                )}
              </StyledCard>
            </Grid2>
          </Grid2>

          {/* Loading Backdrop */}
          <Backdrop open={loading} sx={{ color: "#fff", zIndex: 9999 }}>
            <Box sx={{ textAlign: "center" }}>
              <CircularProgress color="inherit" size={60} sx={{ mb: 2 }} />
              <Typography variant="h6">Processing your content...</Typography>
              <Typography variant="body2" sx={{ opacity: 0.8 }}>
                AI is working its magic
              </Typography>
            </Box>
          </Backdrop>

          {/* Success Snackbar */}
          <Snackbar
            open={showSuccess}
            autoHideDuration={3000}
            onClose={() => setShowSuccess(false)}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          >
            <Alert
              severity="success"
              sx={{
                borderRadius: 2,
                backgroundColor: isDarkMode ? "#065f46" : undefined,
                color: isDarkMode ? "white" : undefined,
              }}
            >
              {successMessage || "Action completed successfully!"}
            </Alert>
          </Snackbar>
        </Container>

        <style jsx>{`
          @keyframes pulse {
            0%,
            100% {
              opacity: 1;
            }
            50% {
              opacity: 0.5;
            }
          }
        `}</style>
      </Box>
    </>
  );
};

export default ModernSummarizer;